<template>
  <keep-alive exclude="RateDetail">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
export default {};
</script>

<style>
</style>
